<div class="app-container">
  <mat-toolbar class="noname-toolbar">
    <div class="left-side">
      <button
        (click)="sidenav.toggle()"
        *ngIf="eventStarted"
        mat-icon-button
        class="menu-icon"
      >
        <mat-icon>menu</mat-icon>
      </button>
      <span class="noname-toolbar">[{{ siteName }}]</span>
    </div>
    <span class="user-name" *ngIf="userName">{{ userName }}</span>
  </mat-toolbar>
  <mat-sidenav-container class="main-container">
    <mat-sidenav class="sidenav-container" #sidenav mode="over">
      <div *ngIf="eventStarted">
        <div
          class="sidenav-buttons"
          *ngFor="let menu of sidnavButtons; last as isLast"
        >
          <div class="menu-item" *ngIf="!isLast" (click)="sidenav.close()" [routerLink]="menu.url">
            <i class="menu-icon" [ngClass]="menu.icon"></i>
            <span class="menu-label">{{ menu.title }}</span>
          </div>
          <div class="menu-item" *ngIf="isLast" (click)="lastButton(menu.url); sidenav.close()">
            <i class="menu-icon" [ngClass]="menu.icon"></i>
            <span class="menu-label">{{ menu.title }}</span>
          </div>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="app-content">
        <div class="app-wrapper">
          <router-outlet></router-outlet>
        </div>
        <div class="footer">
          <img
            class="footer-logo"
            src="assets/images/loho-hb.png"
            alt="Sorry"
          />
          <div class="footer-text-container">
            <div>
              To nejcennější, co máme, je náš životní čas. Jak ho využiješ, je
              na Tobě.
            </div>
            <div class="divider"></div>
            <div>Kolik do toho dáš, tolik se ti vrátí</div>
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
